import { log } from '@/logger/logger';
import { assetUrl } from './assetUrls';
import { extensionFromMimeType } from './mimeTypes';
import type { ResolvedAssets } from '@/types/api/assets';
import type { DownloadableAsset } from '@/types/downloadable';

const logger = log.getLogger('downloadAssets');

/** Points a download at the asset's resolved Blobstore URL instead of its persisted Cloudinary one. */
export function resolveForDownload(asset: DownloadableAsset, resolved: ResolvedAssets): DownloadableAsset {
  const assetId = asset.blobstore?.id;
  if (!assetId) {
    return asset;
  }

  if (!resolved[assetId]) {
    logger.warn(`No resolved Blobstore asset for asset id ${assetId}; downloading from Cloudinary`);
    return asset;
  }

  const extension = extensionFromMimeType(asset.mime, asset.type);

  return { ...asset, url: assetUrl(asset, resolved), extension };
}
